import { editorial } from "@/mocks/homeContent";

export default function FeaturedEditorial() {
  return (
    <section id="exclusive" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">黑料社 · 深挖特稿</p>
          <h3 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">本周独家</h3>
        </div>
        <a href="#review" className="whitespace-nowrap text-sm text-foreground-600 underline-offset-4 hover:text-primary-600 hover:underline">
          全部特稿 <i className="ri-arrow-right-line align-middle" />
        </a>
      </div>

      <div className="mt-8 overflow-hidden rounded-xl border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="flex flex-col justify-center p-7 md:p-12 lg:col-span-7">
            <span className="inline-flex w-fit items-center gap-2 rounded-md bg-primary-600 px-3 py-1 text-xs font-medium tracking-widest text-background-50">
              <i className="ri-fire-line" /> {editorial.eyebrow}
            </span>
            <h4 className="mt-6 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[30px] md:leading-[1.4]">
              {editorial.title}
            </h4>
            <p className="mt-5 text-[15px] leading-relaxed text-foreground-600">{editorial.standfirst}</p>
            <blockquote className="mt-6 border-l-2 border-accent-500 pl-4 font-heading text-base font-medium italic leading-relaxed text-accent-700 md:text-lg">
              {editorial.pullquote}
            </blockquote>
            <div className="mt-7 flex flex-wrap items-center gap-3 border-t border-background-200 pt-5 text-xs text-foreground-600">
              <span className="flex items-center gap-2"><i className="ri-user-line" />{editorial.byline}</span>
              {editorial.meta.map((m) => (
                <span key={m} className="rounded-full bg-secondary-200 px-3 py-1 text-foreground-700">{m}</span>
              ))}
              <span className="ml-auto flex items-center gap-1 text-primary-600">
                <i className="ri-book-open-line" /> 全文约 3.4 万字
              </span>
            </div>
          </div>

          <div className="relative min-h-[280px] lg:col-span-5">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20documentary%20photography%20of%20a%20solemn%20gavel%20and%20auction%20documents%20on%20a%20dark%20wooden%20table%2C%20deep%20vermillion%20and%20ink%20black%20tones%2C%20heavy%20film%20grain%2C%20low%20key%20cinematic%20light%2C%20moody%20investigative%20journalism%20style&width=1100&height=900&seq=editorial-cover&orientation=portrait"
              alt={editorial.title}
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}